import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/BrandLeaderBoardSagas";

const UpdateBtns = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.brandLeaderboard.filtersDirty);

  return (
    filtersDirty && (
      <div className="action-buttons">
        <button className="submit" onClick={() => dispatch(actionCreators.updateTableData())}>
          Update
        </button>
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      </div>
    )
  );
};

export default UpdateBtns;
